"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pressureEquipmentDirective = void 0;
const types_1 = require("../../../types");
exports.pressureEquipmentDirective = {
    directiveId: "2014/68",
    label: "directives.questions.pressureEquipment.label",
    name: "pressureEquipmentDirective",
    subline: "directives.questions.pressureEquipment.subline",
    fields: [
        {
            name: "security_part",
            label: "directives.questions.pressureEquipment.security_part.label",
            type: types_1.FormFieldType.radio,
            options: [
                { label: "yes", value: 1 },
                { label: "no", value: 0 },
            ],
        },
    ],
};
exports.default = exports.pressureEquipmentDirective;
